<template>
  <slice
    :id="block._key"
    class="slice--column-content container container--padding"
  >
    <div class="inner">
      <div class="row-md justify-center">
        <div class="col-md-10">
          <div class="row-md row-no-wrap">
            <div
              v-for="column in block.columns"
              :key="column._key"
              class="col col-grow col-md-full"
              :class="{
                'text-md-center': column.text_align === 'center',
                'text-md-right': column.text_align === 'right',
              }"
            >
              <portable-text
                v-if="column.text && column.text.length > 0"
                :blocks="column.text"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'

import PortableText from '@/components/RichText/PortableText'

export default {
  name: 'BlockColumns',
  components: { Slice, PortableText },
  props: {
    block: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.slice--column-content {
  .inner {
    p:last-child {
      margin-bottom: 0;
    }
  }

  .row-md {
    @include mq($from: tablet) {
      margin: 0 rem(-$spacing * 1.5);
    }
  }

  .col {
    @include mq($from: tablet) {
      padding: 0 rem($spacing * 1.5);
    }

    @include mq($until: tablet) {
      margin-bottom: rem($spacing * 2);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
